<template>
  <span class="infoBlock" :class="`is-${type}`">
    <slot> </slot>
    <b-icon class="infoBlock__icon" :icon="icon" size="is-small" />
  </span>
</template>

<script>
export default {
  props: {
    type: {
      required: true,
      validator: (val) => ["error", "success"].includes(val),
    },
  },

  computed: {
    icon() {
      return this.type === "success" ? "check-circle" : "alert-circle";
    },
  },
};
</script>

<style lang="scss" scoped>
.infoBlock {
  $root: &;

  display: block;
  position: relative;
  font-family: $font-family-title;
  font-weight: 600;
  font-size: 13px;
  padding: 10px 12px;
  border-radius: 2px;
  color: #fff;
  line-height: 1.2;

  &__label {
    color: inherit;
  }

  &__icon {
    position: absolute;
    left: 100%;
    top: 50%;
    margin-left: 8px;
    transform: translateY(-50%) scale(1.3);
  }

  &.is-error {
    $color: #e55760;
    background: $color;

    #{$root}__icon {
      color: $color;
    }
  }

  &.is-success {
    $color: #99bc43;
    background: $color;

    #{$root}__icon {
      color: $color;
    }
  }
}
</style>
